module.exports = __webpack_public_path__ + "img/bg_edu_tech.9e0a197.png";